
import { NavLink } from 'react-router-dom';
import { Calendar, MapPin, Users } from 'lucide-react';

interface RallyCardProps {
  id: string;
  title: string;
  date: string;
  location: string;
  image: string;
  attendees: number;
  featured?: boolean;
}

const RallyCard = ({
  id,
  title,
  date,
  location,
  image,
  attendees,
  featured = false,
}: RallyCardProps) => {
  return (
    <NavLink 
      to={`/rallies/${id}`}
      className={`group block overflow-hidden rounded-lg bg-adv-charcoal border border-adv-darkGray/30 transition-all duration-300 hover:shadow-xl ${
        featured ? 'md:col-span-2 md:row-span-2' : ''
      }`}
    >
      <div className="relative overflow-hidden aspect-[16/9]">
        <img
          src={image}
          alt={title}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-adv-dark to-transparent"></div>
        {featured && (
          <div className="absolute top-4 left-4 bg-adv-orange text-white text-xs font-medium px-2.5 py-1 rounded">
            Featured
          </div>
        )}
      </div>
      <div className="p-5">
        <div className="mb-2 flex flex-wrap gap-2">
          <div className="flex items-center text-xs text-adv-lightGray">
            <Calendar size={14} className="mr-1" /> {date}
          </div>
          <div className="flex items-center text-xs text-adv-lightGray">
            <MapPin size={14} className="mr-1" /> {location}
          </div>
          <div className="flex items-center text-xs text-adv-lightGray">
            <Users size={14} className="mr-1" /> {attendees} riders
          </div>
        </div>
        <h3 className={`font-bold text-white transition-colors group-hover:text-adv-orange ${
          featured ? 'text-xl md:text-2xl' : 'text-lg'
        }`}>
          {title}
        </h3>
        <div className="mt-4 flex items-center text-adv-orange font-medium text-sm">
          Learn More
          <svg className="ml-1 w-4 h-4 transition-transform group-hover:translate-x-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
          </svg>
        </div>
      </div>
    </NavLink>
  );
};

export default RallyCard;
